<template>
	<div>
		<template v-if="device!='pc'">
			<van-field :required="formCreateInject.rule.validate.required" readonly
				:label="formCreateInject.prop.title.title" :value="textValue" placeholder="" @click="show"
				input-align="right">
				<template #left-icon>
					<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
				</template>
			</van-field>
			<van-popup v-model="showPicker" round position="bottom">
				<van-picker value-key="label" show-toolbar :columns="options" :title="formCreateInject.prop.title.title"
					@cancel="showPicker = false" @confirm="onConfirm" />
			</van-popup>
		</template>
		<template v-else>
			<template v-if="!renderCell">
				<div v-if="!readonly">
					<el-select :value="value" :size="size" :placeholder="placeholder" :disabled="disabled"
						@change="change" clearable transfer filterable :multiple="multiple" :collapse-tags="collapseTags">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div v-else>
					<el-input v-model="textValue" :size="size"></el-input>
				</div>
			</template>
			<template v-else>
				<span>{{textValue}}</span>
			</template>
		</template>

	</div>
</template>

<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				ready: false,
				sourceData: [],
				options: [],
				showPicker: false,
				device: window.systemMethods.device()
			}
		},
		created() {

		},
		watch: {
			value(e) {
				this.change(e)
			}
		},
		computed: {
			textValue() {
				let text = ''
				if (Array.isArray(this.value)) {
					let options = []
					let arr = []
					options = this.options
					this.value.forEach((item) => {
						for (let i = 0; i < options.length; i++) {
							if (options[i].value == item) {
								arr.push(options[i].label)
								options = options[i].children ? options[i].children : []
								break
							}
						}

					})
					text = arr.join('/')
				} else {

					for (let i = 0; i < this.options.length; i++) {
						if (this.options[i].value == this.value) {
							text = this.options[i].label
							break
						}
					}
				}
				return text
			}
		},

		methods: {
			show() {
				if (!this.disabled && !this.readonly) {
					this.showPicker = true
				}
			},
			list() {
				if (!window.systemData.warehouse) {
					this.$api.warehouse.list({
						currentPage: -1
					}).then((res) => {
						let options = []
						res.list.forEach((item) => {
							options.push({
								value: item.id,
								label: item.name
							})
						})
						this.options = options
						this.finish()
					})
				} else {
					let list = JSON.parse(JSON.stringify(window.systemData.warehouse))
					let options = []
					list.forEach((item) => {
						options.push({
							value: item.id,
							label: item.name
						})
					})
					this.options = options
					this.finish()
				}

			}
		}
	}
</script>
